import React, { useState } from "react";
import { observer } from "mobx-react";
import QuestionareStore from "../stores/QuestionareStore";

function TextBoxComponent({inputKey, isHindi}){
    const handleOnChange = (event) =>{
        QuestionareStore.setTextInputValue(inputKey, event.target.value)
    }
    return(
        <textarea 
            id="input-form"
            placeholder= {isHindi ? "अपने विचार यहाँ लिखें" : "Write your thoughts below"}
            value={QuestionareStore.getTextInputValue(inputKey)}
            onChange={handleOnChange}
            name="inputForm"
            style={{width:'20rem', 
                height: '16rem', 
                border: 'none', 
                padding: '1rem',
                borderRadius:'12px',
                backgroundColor:'#F9F7F4',
                outline: 'none',
                fontSize: '1rem'
            }}
        />
    )
} 

export default observer(TextBoxComponent);